import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SnowshoeingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"snowshoeing"}/>
}
